@if (token) {
  <pay-login-password-reset [token]="this.token" (passwordResetDone)="routeToNextPage($event)" />
}
